module.exports = __webpack_public_path__ + "img/联系我们_总部地址.228ab1a4.svg";